import { useNavigate } from 'react-router-dom';
import { FLOX_LOGO_BLUE_SRC } from '@constants';
import { useDocumentTitle } from 'usehooks-ts';
import { ClockIcon, EnvelopeIcon } from '@heroicons/react/24/outline';
import { Button } from '../../tailwindComponents/Button';

export function PendingApproval() {
  const navigate = useNavigate();
  useDocumentTitle('FLOX - Pending Approval');

  return (
    <main className='flex min-h-screen w-full'>
      {/* Image Panel */}
      <section
        className='hidden lg:block lg:w-1/2 min-h-screen bg-cover bg-no-repeat bg-center transition-all duration-300'
        style={{ backgroundImage: 'url(/images/bg-register.png)' }}
      />

      {/* Content Panel */}
      <section className='flex-1 flex items-center justify-center bg-white px-4 py-12'>
        <div className='w-full max-w-lg text-center'>
          {/* Logo */}
          <div className='flex justify-center mb-6'>
            <img
              src={FLOX_LOGO_BLUE_SRC}
              alt='Flox logo'
              className='h-14 w-auto'
            />
          </div>

          {/* Icon */}
          <div className='flex justify-center mb-6'>
            <div className='bg-blue-100 rounded-full p-4'>
              <ClockIcon className='h-12 w-12 text-blue-600' />
            </div>
          </div>

          {/* Title */}
          <h1 className='text-3xl font-bold text-gray-900 mb-4'>
            Account Pending Approval
          </h1>

          {/* Description Card */}
          <div className='bg-white rounded-2xl shadow-lg border border-gray-100 p-8 mb-8'>
            <div className='bg-blue-50 rounded-lg p-6 mb-6'>
              <div className='flex items-start gap-3'>
                <EnvelopeIcon className='h-6 w-6 text-blue-600 flex-shrink-0 mt-0.5' />
                <div className='text-left'>
                  <p className='text-gray-700 font-medium mb-2'>
                    Your account is pending approval
                  </p>
                  <p className='text-gray-600 text-sm'>
                    We have notified your Business Administrator. You will
                    receive an email confirmation once your account has been
                    approved and you can log in to FLOX.
                  </p>
                </div>
              </div>
            </div>

            <div className='text-sm text-gray-500 mb-6'>
              <p>This usually takes 1-2 business days.</p>
              <p className='mt-2'>
                If you have any questions, please contact your administrator or
                reach out to our support team.
              </p>
            </div>

            <Button
              type='button'
              intent='secondary'
              size='lg'
              onClick={() => navigate('/login')}
              className='w-full'
              label='Back to Login'
            />
          </div>

          {/* Support Link */}
          <p className='text-sm text-gray-400'>
            Need help? Contact{' '}
            <a
              href='mailto:support@flox.is'
              className='text-blue-600 hover:underline'
            >
              support@flox.is
            </a>
          </p>
        </div>
      </section>
    </main>
  );
}
